import { Image } from 'expo-image';
import { PresenceTransition, Box } from 'native-base';

export interface AnimatedShuffleViewProps {
  color?: string;
  avatar?: string;
  visible?: boolean;
  size?: number;
}

export const AnimatedShuffleView = ({
  color,
  avatar,
  visible = true,
  size = 100,
}: AnimatedShuffleViewProps) => {
  return (
    <PresenceTransition
      visible={visible}
      initial={{
        opacity: 0,
        scale: 0,
        rotate: '18deg',
      }}
      animate={{
        opacity: 1,
        scale: 1,
        rotate: '0deg',
        transition: {
          duration: 100,
        },
      }}
    >
      <Box
        rounded={'full'}
        alignSelf={'center'}
        bg={color}
        alignItems={'center'}
        justifyContent={'center'}
        size={size}
      >
        <Image
          contentFit={'contain'}
          source={{ uri: avatar }}
          cachePolicy={'memory'}
          accessibilityLabel={`${avatar} avatar`}
          style={{
            width: '100%',
            aspectRatio: 1,
          }}
        />
      </Box>
    </PresenceTransition>
  );
};
